// Fonte única de verdade para as cores do fluxo de encomendas.
//
// DemoThemeProvider always injects --demo-primary / --demo-secondary /
// --demo-tertiary / --demo-header on <html> — either from the demo color
// picker (NEXT_PUBLIC_DEMO=true) or from the Strapi partner theme.
// Every component using these exports in an inline style automatically
// picks up live changes — CSS var() resolves at paint time.

export const primaryColor = "var(--demo-primary)";
export const secondaryColor = "var(--demo-secondary)";
export const tertiaryColor = "var(--demo-tertiary)";

// Raw hex fallbacks for non-style contexts (e.g. Leaflet, canvas).
export const primaryColorHex = "#292929";
export const secondaryColorHex = "#ffff00";
export const tertiaryColorHex = "#6C7C93";
